/**
 * @flow
 * @relayHash 931e3d721737ed7d1b755593529171ef
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type project_viewer$ref = any;
export type project_QueryVariables = {|
  id: string,
  isDefaultRoute: boolean,
|};
export type project_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: project_viewer$ref,
  |},
|};
*/


/*
query project_Query(
  $id: ID!
  $isDefaultRoute: Boolean!
) {
  viewer {
    ...project_viewer
    id
  }
}

fragment project_viewer on Viewer {
  latest_project {
    id
    is_public
    name
    notes
    opaque_id
    tracks(first: 100) {
      edges {
        id
        version
        node {
          id
          internal_id
          price
          base_price
          title
          added_to_cart
          slug
          duration
          score
          boosted_score
          stems_available
          customizable
          matched_exclusions
          tempos {
            id
            name
            value
          }
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
          artist {
            id
            name
            slug
            bio
            bandcamp
            facebook
            instagram
            itunes
            soundcloud
            spotify
            twitter
            wiki
            youtube
            homebase
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
          }
          terms(first: 100) {
            edges {
              node {
                id
                is_highlighted
                name
                parent_id
                taxonomy {
                  id
                  internal_id
                  name
                }
              }
            }
          }
          collections {
            edges {
              node {
                id
                description
                name
                slug
                category {
                  id
                  name
                }
                assets {
                  id
                  version
                  type
                  file_format
                  path
                  metadata
                }
              }
              id
            }
          }
          association_id
          selected_version
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    owner {
      id
      first_name
      last_name
      user_id
    }
    users {
      id
      first_name
      last_name
      user_id
      role
    }
    license_params {
      spot_count
      term
      medium
      contextual_param
      contextual_param_type
    }
  }
  projects(first: 100, scope: CurrentUser) {
    edges {
      node {
        id
        is_public
        name
        notes
        tracks(first: 100) {
          edges {
            id
            cursor
            node {
              __typename
              id
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        owner {
          id
          first_name
          last_name
          user_id
        }
        users {
          id
          first_name
          last_name
          user_id
          role
        }
        license_params {
          spot_count
          term
          medium
          contextual_param
          contextual_param_type
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  node(id: $id) @skip(if: $isDefaultRoute) {
    __typename
    ... on Project {
      id
      is_public
      name
      notes
      opaque_id
      tracks(first: 100) {
        edges {
          id
          version
          node {
            id
            internal_id
            price
            base_price
            title
            added_to_cart
            slug
            duration
            score
            boosted_score
            stems_available
            customizable
            matched_exclusions
            tempos {
              id
              name
              value
            }
            assets {
              id
              version
              type
              file_format
              path
              metadata
            }
            artist {
              id
              name
              slug
              bio
              bandcamp
              facebook
              instagram
              itunes
              soundcloud
              spotify
              twitter
              wiki
              youtube
              homebase
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            terms(first: 100) {
              edges {
                node {
                  id
                  is_highlighted
                  name
                  parent_id
                  taxonomy {
                    id
                    internal_id
                    name
                  }
                }
              }
            }
            collections {
              edges {
                node {
                  id
                  description
                  name
                  slug
                  category {
                    id
                    name
                  }
                  assets {
                    id
                    version
                    type
                    file_format
                    path
                    metadata
                  }
                }
                id
              }
            }
            association_id
            selected_version
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      owner {
        id
        first_name
        last_name
        user_id
      }
      users {
        id
        first_name
        last_name
        user_id
        role
      }
      license_params {
        spot_count
        term
        medium
        contextual_param
        contextual_param_type
      }
    }
    id
  }
  selected_currency
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isDefaultRoute",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_public",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "opaque_id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 100,
  "type": "Int"
},
v7 = [
  v6
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "version",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v1,
    v8,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tracks",
  "storageKey": "tracks(first:100)",
  "args": v7,
  "concreteType": "ProjectTrackConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectTrackEdge",
      "plural": true,
      "selections": [
        v1,
        v8,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "stems_available",
              "args": null,
              "storageKey": null
            },
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "base_price",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "added_to_cart",
              "args": null,
              "storageKey": null
            },
            v9,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "duration",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "score",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "boosted_score",
              "args": null,
              "storageKey": null
            },
            v10,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "customizable",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "matched_exclusions",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "tempos",
              "storageKey": null,
              "args": null,
              "concreteType": "Tempo",
              "plural": true,
              "selections": [
                v1,
                v3,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            v11,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "itunes",
                  "args": null,
                  "storageKey": null
                },
                v1,
                v9,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bio",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bandcamp",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "facebook",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "instagram",
                  "args": null,
                  "storageKey": null
                },
                v3,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "soundcloud",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "spotify",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "twitter",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "wiki",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "youtube",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "homebase",
                  "args": null,
                  "storageKey": null
                },
                v11
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "terms",
              "storageKey": "terms(first:100)",
              "args": v7,
              "concreteType": "TaxonomyTermConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TaxonomyTermEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTerm",
                      "plural": false,
                      "selections": [
                        v1,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "is_highlighted",
                          "args": null,
                          "storageKey": null
                        },
                        v3,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "parent_id",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "taxonomy",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Taxonomy",
                          "plural": false,
                          "selections": [
                            v1,
                            v10,
                            v3
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "collections",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionTrackConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Collection",
                      "plural": false,
                      "selections": [
                        v1,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "description",
                          "args": null,
                          "storageKey": null
                        },
                        v3,
                        v9,
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "category",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "CollectionCategory",
                          "plural": false,
                          "selections": [
                            v1,
                            v3
                          ]
                        },
                        v11
                      ]
                    },
                    v1
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "association_id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "selected_version",
              "args": null,
              "storageKey": null
            },
            v12
          ]
        },
        v13
      ]
    },
    v14
  ]
},
v16 = {
  "kind": "LinkedHandle",
  "alias": null,
  "name": "tracks",
  "args": v7,
  "handle": "connection",
  "key": "project_tracks",
  "filters": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "owner",
  "storageKey": null,
  "args": null,
  "concreteType": "ProjectUser",
  "plural": false,
  "selections": [
    v1,
    v17,
    v18,
    v19
  ]
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "users",
  "storageKey": null,
  "args": null,
  "concreteType": "ProjectUser",
  "plural": true,
  "selections": [
    v1,
    v17,
    v18,
    v19,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "role",
      "args": null,
      "storageKey": null
    }
  ]
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "license_params",
  "storageKey": null,
  "args": null,
  "concreteType": "LicenseUsageParams",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "spot_count",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "term",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "medium",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param_type",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "project_Query",
  "id": null,
  "text": "query project_Query(\n  $id: ID!\n  $isDefaultRoute: Boolean!\n) {\n  viewer {\n    ...project_viewer\n    id\n  }\n}\n\nfragment project_viewer on Viewer {\n  latest_project {\n    id\n    is_public\n    name\n    notes\n    opaque_id\n    tracks(first: 100) {\n      edges {\n        id\n        version\n        node {\n          id\n          internal_id\n          price\n          base_price\n          title\n          added_to_cart\n          slug\n          duration\n          score\n          boosted_score\n          stems_available\n          customizable\n          matched_exclusions\n          tempos {\n            id\n            name\n            value\n          }\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n          artist {\n            id\n            name\n            slug\n            bio\n            bandcamp\n            facebook\n            instagram\n            itunes\n            soundcloud\n            spotify\n            twitter\n            wiki\n            youtube\n            homebase\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n          }\n          terms(first: 100) {\n            edges {\n              node {\n                id\n                is_highlighted\n                name\n                parent_id\n                taxonomy {\n                  id\n                  internal_id\n                  name\n                }\n              }\n            }\n          }\n          collections {\n            edges {\n              node {\n                id\n                description\n                name\n                slug\n                category {\n                  id\n                  name\n                }\n                assets {\n                  id\n                  version\n                  type\n                  file_format\n                  path\n                  metadata\n                }\n              }\n              id\n            }\n          }\n          association_id\n          selected_version\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    owner {\n      id\n      first_name\n      last_name\n      user_id\n    }\n    users {\n      id\n      first_name\n      last_name\n      user_id\n      role\n    }\n    license_params {\n      spot_count\n      term\n      medium\n      contextual_param\n      contextual_param_type\n    }\n  }\n  projects(first: 100, scope: CurrentUser) {\n    edges {\n      node {\n        id\n        is_public\n        name\n        notes\n        tracks(first: 100) {\n          edges {\n            id\n            cursor\n            node {\n              __typename\n              id\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        owner {\n          id\n          first_name\n          last_name\n          user_id\n        }\n        users {\n          id\n          first_name\n          last_name\n          user_id\n          role\n        }\n        license_params {\n          spot_count\n          term\n          medium\n          contextual_param\n          contextual_param_type\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  node(id: $id) @skip(if: $isDefaultRoute) {\n    __typename\n    ... on Project {\n      id\n      is_public\n      name\n      notes\n      opaque_id\n      tracks(first: 100) {\n        edges {\n          id\n          version\n          node {\n            id\n            internal_id\n            price\n            base_price\n            title\n            added_to_cart\n            slug\n            duration\n            score\n            boosted_score\n            stems_available\n            customizable\n            matched_exclusions\n            tempos {\n              id\n              name\n              value\n            }\n            assets {\n              id\n              version\n              type\n              file_format\n              path\n              metadata\n            }\n            artist {\n              id\n              name\n              slug\n              bio\n              bandcamp\n              facebook\n              instagram\n              itunes\n              soundcloud\n              spotify\n              twitter\n              wiki\n              youtube\n              homebase\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            terms(first: 100) {\n              edges {\n                node {\n                  id\n                  is_highlighted\n                  name\n                  parent_id\n                  taxonomy {\n                    id\n                    internal_id\n                    name\n                  }\n                }\n              }\n            }\n            collections {\n              edges {\n                node {\n                  id\n                  description\n                  name\n                  slug\n                  category {\n                    id\n                    name\n                  }\n                  assets {\n                    id\n                    version\n                    type\n                    file_format\n                    path\n                    metadata\n                  }\n                }\n                id\n              }\n            }\n            association_id\n            selected_version\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      owner {\n        id\n        first_name\n        last_name\n        user_id\n      }\n      users {\n        id\n        first_name\n        last_name\n        user_id\n        role\n      }\n      license_params {\n        spot_count\n        term\n        medium\n        contextual_param\n        contextual_param_type\n      }\n    }\n    id\n  }\n  selected_currency\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "project_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "project_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "project_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "latest_project",
            "storageKey": null,
            "args": null,
            "concreteType": "Project",
            "plural": false,
            "selections": [
              v1,
              v2,
              v3,
              v4,
              v5,
              v15,
              v16,
              v20,
              v21,
              v22
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "projects",
            "storageKey": "projects(first:100,scope:\"CurrentUser\")",
            "args": [
              v6,
              {
                "kind": "Literal",
                "name": "scope",
                "value": "CurrentUser",
                "type": "QueryScopeEnumType!"
              }
            ],
            "concreteType": "ProjectConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Project",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      v3,
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tracks",
                        "storageKey": "tracks(first:100)",
                        "args": v7,
                        "concreteType": "ProjectTrackConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProjectTrackEdge",
                            "plural": true,
                            "selections": [
                              v1,
                              v13,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TrackSearchResult",
                                "plural": false,
                                "selections": [
                                  v12,
                                  v1
                                ]
                              }
                            ]
                          },
                          v14
                        ]
                      },
                      v16,
                      v20,
                      v21,
                      v22,
                      v12
                    ]
                  },
                  v13
                ]
              },
              v14
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "projects",
            "args": [
              v6,
              {
                "kind": "Literal",
                "name": "scope",
                "value": "CurrentUser",
                "type": "QueryScopeEnumType!"
              }
            ],
            "handle": "connection",
            "key": "list_projects",
            "filters": []
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_currency",
            "args": null,
            "storageKey": null
          },
          v1,
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "isDefaultRoute",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id",
                    "type": "ID!"
                  }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                  v12,
                  v1,
                  {
                    "kind": "InlineFragment",
                    "type": "Project",
                    "selections": [
                      v2,
                      v3,
                      v4,
                      v5,
                      v15,
                      v16,
                      v20,
                      v21,
                      v22
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '5e6fe59ea62415891e084c8a07585553';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/project_Query.graphql.js